import { render } from "./TaskToProcess.vue?vue&type=template&id=fa1c41be"
import script from "./TaskToProcess.vue?vue&type=script&lang=js"
export * from "./TaskToProcess.vue?vue&type=script&lang=js"

import "./TaskToProcess.vue?vue&type=style&index=0&id=fa1c41be&lang=less"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\cloud_share_lib\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__